import serviceTest from "./serviceTest";
import serviceBff from "./serviceBff";
import constants from "../../config/constants";

const getParams = dataSource => {
  let params = {};

  dataSource.params.map(param => {
    switch (param.sourceType) {
      case constants.PARAM_TYPE_STATIC_VALUE:
        params[param.name] = param.value;
        break;
      case constants.PARAM_TYPE_GLOBAL_STATE_VALUE:
        const paramValue = dataSource.globalStateValues[param.sourceId];
        params[param.name] = "";

        if (paramValue !== undefined) {
          params[param.name] = paramValue.hasOwnProperty("id") ? paramValue.id : paramValue;
        }
        break;
      default:
        return false;
    }

    return false;
  });

  return params;
};

const getGlobalValue = dataSource => {
  const params = dataSource.params.map(param => {
    const globalField = dataSource.globalStateValues[param.sourceId];

    if (globalField !== undefined) {
      return {
        id: globalField.id ?? globalField.value,
        label: globalField.name ?? globalField.label
      };
    }
    return false;
  });

  return params;
};

const fetchSourceData = async dataSource => {
  const inputData = getParams(dataSource);
  switch (dataSource.source) {
    case constants.SERVICE_TEST:
      return await serviceTest(dataSource.endpoint, inputData);
    case constants.SERVICE_BFF:
      return await serviceBff(dataSource.endpoint, inputData);
    default:
      return "";
  }
};

const dataSourceAggregator = async dataSource => {
  switch (dataSource.type) {
    case constants.DATASOURCE_TYPE_JSON:
      return dataSource.source !== undefined ? dataSource.source : [];
    case constants.DATASOURCE_TYPE_API:
      return await fetchSourceData(dataSource);
    case constants.DATASOURCE_TYPE_GLOBAL_VALUE:
      return getGlobalValue(dataSource);
    default:
      return "";
  }
};

export default dataSourceAggregator;
